import React, { useState } from 'react';
import SEO from '../components/SEO';
import ScrollReveal from '../components/ScrollReveal';
import CTASection from '../components/CTASection';
import '../styles/contactPage.css';

function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setSubmitted(true);

    setTimeout(() => {
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
      setSubmitted(false);
    }, 3000);
  };

  return (
    <>
      <SEO
        title="Contact Us"
        description="Contact QASHQ Business & IT Consultants for a free consultation. Reach us by email, phone, or WhatsApp — Rawalpindi, Pakistan."
        path="/contact"
      />
      <main className="main-content contact-page">
        <section className="page-hero contact-header">
          <div className="container">
            <ScrollReveal className="page-hero-inner">
              <p className="section-eyebrow">Contact</p>
              <h1 className="contact-header-title">Get in touch with QASHQ</h1>
              <p className="contact-header-subtitle">
                We'd love to hear from you. Reach out to discuss your business goals, technology needs,
                or to book a free consultation.
              </p>
            </ScrollReveal>
          </div>
        </section>

        <section className="section contact-section">
          <div className="container">
            <div className="contact-wrapper">
              <ScrollReveal className="contact-info">
                <h2 className="contact-info-title">Contact Information</h2>

                <div className="contact-item">
                  <div className="contact-item-inner">
                    <div className="contact-icon">
                      <ion-icon name="mail-outline"></ion-icon>
                    </div>
                    <div>
                      <h3>Email</h3>
                      <a href="mailto:contact.qashq@gmail.com">contact.qashq@gmail.com</a>
                    </div>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-item-inner">
                    <div className="contact-icon">
                      <ion-icon name="call-outline"></ion-icon>
                    </div>
                    <div>
                      <h3>Phone</h3>
                      <a href="tel:+923479310319">+92 347 9310319</a>
                    </div>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-item-inner">
                    <div className="contact-icon">
                      <ion-icon name="logo-whatsapp"></ion-icon>
                    </div>
                    <div>
                      <h3>WhatsApp</h3>
                      <a href="https://wa.me/923479310319" target="_blank" rel="noopener noreferrer">
                        +92 347 9310319
                      </a>
                    </div>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-item-inner">
                    <div className="contact-icon">
                      <ion-icon name="location-outline"></ion-icon>
                    </div>
                    <div>
                      <h3>Location</h3>
                      <p>
                        Transformer Chowk, Sadiqabad
                        <br />
                        Rawalpindi, Pakistan
                      </p>
                    </div>
                  </div>
                </div>

                <div className="business-hours">
                  <h3>Business Hours</h3>
                  <div>
                    <p>
                      <strong>Monday - Friday:</strong> 9:00 AM - 6:00 PM
                    </p>
                    <p>
                      <strong>Saturday:</strong> 10:00 AM - 4:00 PM
                    </p>
                    <p>
                      <strong>Sunday:</strong> Closed
                    </p>
                    <p>
                      <strong>24/7 Support:</strong> Available via Email &amp; WhatsApp
                    </p>
                  </div>
                </div>
              </ScrollReveal>

              <ScrollReveal className="contact-form-wrapper">
                <h2 className="contact-form-title">Send us a message</h2>

                {submitted ? (
                  <div className="success-message" role="status">
                    <ion-icon name="checkmark-circle-outline" className="success-icon"></ion-icon>
                    <p className="success-title">Thank you!</p>
                    <p>We've received your message and will get back to you soon.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <label className="form-label" htmlFor="contact-name">
                        Full Name *
                      </label>
                      <input
                        id="contact-name"
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="form-input"
                        autoComplete="name"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label" htmlFor="contact-email">
                        Email Address *
                      </label>
                      <input
                        id="contact-email"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="form-input"
                        autoComplete="email"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label" htmlFor="contact-phone">
                        Phone Number
                      </label>
                      <input
                        id="contact-phone"
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="form-input"
                        autoComplete="tel"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label" htmlFor="contact-subject">
                        Subject *
                      </label>
                      <input
                        id="contact-subject"
                        type="text"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                        className="form-input"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label" htmlFor="contact-message">
                        Message *
                      </label>
                      <textarea
                        id="contact-message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        rows="6"
                        className="form-input form-textarea"
                      ></textarea>
                    </div>

                    <button type="submit" className="btn btn-secondary submit-btn">
                      Send Message
                    </button>
                  </form>
                )}
              </ScrollReveal>
            </div>
          </div>
        </section>

        <section className="section map-section">
          <div className="container">
            <h2 className="map-title">Visit our office</h2>

            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3321.8275847890567!2d73.06398431520227!3d33.605494480733774!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38df952f3b0e0c8d%3A0x7c5f5b7c8b0e0c8d!2sTransformer%20Chowk%2C%20Sadiqabad%2C%20Rawalpindi%2C%20Punjab%2C%20Pakistan!5e0!3m2!1sen!2s!4v1234567890123!5m2!1sen!2s"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="QASHQ Office Location - Transformer Chowk, Sadiqabad, Rawalpindi"
              ></iframe>
            </div>
            <p className="map-info">Transformer Chowk, Sadiqabad, Rawalpindi, Punjab, Pakistan</p>
          </div>
        </section>

        <CTASection
          variant="burgundy"
          eyebrow="Prefer a direct conversation?"
          title="Book a Free Consultation"
          text="Speak with our team about your business or technology priorities."
          primaryLabel="Contact Us Today"
        />
      </main>
    </>
  );
}

export default ContactPage;
